import { combineReducers } from 'redux'

// TODO: Invert control
import { reducer as loginReducer } from './Modules/AuthNative'
import { reducer as localizationReducer } from './Modules/Localization'
import { reducer as captchaReducer } from './Modules/Captcha'
import { reducer as googleAuthReducer } from './Modules/AuthGoogle'
import { reducer as stripeReducer } from './Modules/Stripe'
import { reducer as csrfReducer } from './Modules/CSRF'

export default combineReducers({
  login:        loginReducer,
  localization: localizationReducer,
  captcha:      captchaReducer,
  googleAuth:   googleAuthReducer,
  stripe:       stripeReducer,
  csrf:         csrfReducer
});
